<template>
  <fragment>
    <div class="cart-drawer__header">
      <div class="x f aic cart-drawer__header-inner">
        <button class="close cart" v-on:click="toggle" aria-label="close cart">
          <span class="f cursor--pointer">
            <svg-caret-left></svg-caret-left>
          </span>
        </button>
        <h1 id="cart-title" class="mv0 plaid-l">
          {{ cartTitle }} ({{ cart.item_count }})
        </h1>
      </div>
    </div>

    <div class="rel cart-drawer__items-outer">
      <div
        class="cart-drawer__items cart-drawer__items-inner x f-a z4"
        ref="cartDrawerScrollable"
      >
        <div
          v-html="shippingCopy"
          v-if="shippingCopy"
          class="fw cart-drawer__shipping-header"
        ></div>

        <!-- Line Items Start -->
        <transition-group tag="ul" name="fade">
          <cart-drawer-line-item
            v-for="(item, index) in sortedItems"
            v-bind:item="item"
            v-bind:index="index"
            v-bind:key="item.id + ':' + index"
          >
          </cart-drawer-line-item>
        </transition-group>
        <!-- LineItems End -->

        <cart-gift-note-toggle v-if="showGiftNotes"></cart-gift-note-toggle>
        <cart-gift-wrap-toggle v-if="showGiftWrap"></cart-gift-wrap-toggle>

        <cart-drawer-upsells :gwpAlert="gwpAlert"> </cart-drawer-upsells>
      </div>

      <cart-gift-wrap
        :giftWrapCollectionImage="giftWrapCollectionImage"
      ></cart-gift-wrap>
      <cart-gift-note></cart-gift-note>

      <portal-target name="cart-bottom"> </portal-target>
    </div>

    <div v-if="savings" class="cart-drawer__savings">
      You save {{ savings }}!
    </div>
    <div
      v-html="shippingNoteInCart"
      v-else-if="shippingNoteInCart"
      class="cart-drawer__in-cart-ship-note"
    ></div>

    <div
      v-if="!giftWrapOpen"
      class="x z5 cart-drawer--bottom bg-warm-white rel"
    >
      <div class="z6 rel x">
        <div class="cart-drawer__subtotal">
          <div>Subtotal</div>
          <div class="total">
            {{ totalPrice }}
          </div>
        </div>

        <div class="x">
          <a
            data-mtr-track="click"
            data-mtr-as="continueToCheckout"
            :data-mtr-data="JSON.stringify(cartPayload)"
            href="/checkout"
            class="button__main caps checkout-button"
          >
            Continue to Checkout
          </a>
        </div>
      </div>
    </div>
  </fragment>
</template>
<script>
import { mapState, mapActions, mapGetters } from "vuex";
import { formatMoney, currencySymbol } from "@/lib/currency";

export default {
  name: "cart-drawer-content",
  data() {
    return {
      hideGiftNote: theme.cartConfig.hideGiftNote,
      hideGiftWrap: theme.cartConfig.hideGiftWrap,
      shippingNoteInCart: theme.cartConfig.shippingNoteInCart || "",
      shippingCopy: theme.cartConfig.shippingCopy || "",
    };
  },
  computed: {
    ...mapState({
      giftFormOpen: (state) => state.cart.giftFormOpen,
      giftWrapOpen: (state) => state.cart.giftWrapOpen,
      giftWrapItems: (state) => state.cart.giftWrapItems,
      variantsMetafields: (state) => state.metafields.variants,
      productsMetafields: (state) => state.metafields.products,
    }),
    ...mapGetters({
      sortedItems: "cart/sortedItems",
      totalPrice: "cart/formattedTotalPrice",
      totalSavings: "cart/totalSavings",
    }),
    availableGiftWrapItems() {
      return this.giftWrapItems.filter(
        (giftWrap) => giftWrap.availableQuantity
      );
    },
    cartPayload() {
      return { $cart: this.cart };
    },
    showGiftNotes() {
      if (this.hideGiftNotes) return false;
      if (!this.hideGiftWrap && this.availableGiftWrapItems.length)
        return false;
      return true;
    },
    showGiftWrap() {
      if (this.hideGiftWrap) return false;
      if (!this.availableGiftWrapItems.length) return false;
      return true;
    },
    savings() {
      if (!this.cart || !this.cart.total_discount) {
        return null;
      }

      return formatMoney(
        this.totalSavings,
        `${currencySymbol()}{{ amount_no_trailing_zeroes }}`
      );
    },
  },
  props: {
    cart: Object,
    cartTitle: String,
    giftWrapCollectionImage: String,
    gwpAlert: String,
  },
  methods: {
    ...mapActions({
      toggle: "cart/toggleCart",
    }),
  },
};
</script>
